import React from "react";
import { Link } from "react-router-dom";
import { FaDiscord, FaRedditAlien, FaPaypal } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-card border-t border-gray-700 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold mb-3">Collect Arena</h3>
            <p className="text-gray-400 text-sm">
              Test your knowledge with curated quiz lists. Guess hidden items
              and complete challenges!
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/how-to-play"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  How to Play
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  Browse Lists
                </Link>
              </li>
              <li>
                <Link
                  to="/register"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-bold mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-settings"
                  className="text-gray-400 hover:text-blue-400 text-sm transition"
                >
                  Cookie Settings
                </Link>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-white font-bold mb-3 text-center">Community</h3>
            <ul className="space-y-3 text-center">
              <li>
                <a
                  href="https://discord.gg/473F5RGH99"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#5865F2] text-sm transition flex items-center justify-center gap-2"
                >
                  <FaDiscord className="w-4 h-4" />
                  Discord
                </a>
              </li>

              <li>
                <a
                  href="https://reddit.com/r/CollectArena"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#FF4500] text-sm transition flex items-center justify-center gap-2"
                >
                  <FaRedditAlien className="w-4 h-4" />
                  Reddit
                </a>
              </li>

              <li>
                <a
                  href="https://www.paypal.com/donate/?hosted_button_id=E3RDQWXNGL266"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#00457C] text-sm transition flex items-center justify-center gap-2"
                >
                  <FaPaypal className="w-4 h-4" />
                  Donate
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Collect Arena. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
